export const notRenewedCcaStudentStatusList = [
  { id: "pending", name: "Pending" },
  { id: "accepted", name: "Accepted" },
  { id: "declined", name: "Declined" },
];
